import { render } from "./OrderSection.vue?vue&type=template&id=24018a60&scoped=true"
import script from "./OrderSection.vue?vue&type=script&lang=js"
export * from "./OrderSection.vue?vue&type=script&lang=js"

import "./OrderSection.vue?vue&type=style&index=0&id=24018a60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24018a60"]])

export default __exports__